import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/faq.css";
import faq from "../../assets/img/landing/faq.svg";
import search from "../../assets/img/sreach---icon.svg";
import termicon from "../../assets/img/terms-con.svg";
import { getFaq, getPageContents } from "../../services/apiOtherlink";
const TermsPopup = (props) => {
 const [TermContent, setTermContent] = useState('');
   useEffect(() => {
       fetchContent()
     }, [])
  
     const fetchContent = async () => {
         let content = await getPageContents();
        
          setTermContent(content.termsAndCondition.template);
     
       }
    const termsClosePopup = () => {
    props.termsClosePopup();
   
  };
  return (
    <div>
         <Modal dialogClassName="custom-modal modal-dialog-centered modal-dialog-scrollable" show={props.termsOpenPopup} onHide={termsClosePopup}>
           <Modal.Header closeButton>
             <div className="popupheader">
               <div className="mod-bor-icon" >
                 <img src={termicon} className="mod-icon black"></img>
               </div>
               <div className="header">
                 <h4 className="modal-tittle">Dreamers Health
Terms and Conditions of Use</h4>
   
               </div>
             </div>
           </Modal.Header>
   
           <Modal.Body>
            <div className="succ-content" dangerouslySetInnerHTML={{ __html: TermContent}} /> 

  <style>{`
        .tc { list-style: none; padding-left: 0; }
        .mt-3 { margin-top: 1rem; }
        .sub-t-c { margin-top: 0.25rem; }
        ul.tc li ol li {
    list-style: auto;
        margin-bottom: 10px;
}
        ul.tc ol {
    padding-left: 16px !important;
    margin-bottom: 0px;
}
      `}</style>
   
      
           </Modal.Body>
           <Modal.Footer className="full-w" >
           
           </Modal.Footer>
         </Modal>
         
       </div>
  );
};
export default TermsPopup;